import * as constants from '@/store/constants'

// Utility functions
export function	toUTCSeconds(epochtime) {
    var d = new Date(0)
    d.setUTCSeconds(epochtime);
    return d.getTime()
}

export function isNull(value) {
    return (value) ? value : ""
}

export function isFloat(n){
    return Number(n) === n && n % 1 !== 0;
}

export function isValidGPSDecimal(value) {
  let reg = new new RegExp("^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$")  
  return reg.exec(value) ? true : false
}

export function findMofaNameById(requestTypeId) {
    let route = null
    switch (requestTypeId) {
      case constants.FORM_AIR:
            route = "air"
            break
      case constants.FORM_LAND_MOVEMENT:
            route = "land"
            break
      case constants.FORM_SEA:
            route = "sea"
            break
      case constants.FORM_TEMP_VENUE:
            route = "temp"
            break
      case constants.FORM_NO_STRIKE_LIST:
            route = "nsl"
            break
	}
    return route
}

export function isEmailValid(value) {
  let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/

  return reg.test(value)  
}

export function authHeader() {
    // JSON.parse(window.localStorage.getItem('decon')).token
    // return authorization header with jwt token
    let user = JSON.parse(window.localStorage.getItem('decon'))

    if (user && user.token) {
        return { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + user.token            
        }
    } 
    else {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
}

export function authHeaderUpload() {
    // JSON.parse(window.localStorage.getItem('decon')).token
    // return authorization header with jwt token
    let user = JSON.parse(window.localStorage.getItem('decon'))

    if (user && user.token) {
        return { 
            'Content-Type' : 'multipart/form-data',
            'Authorization': 'Bearer ' + user.token 
        }
    } 
    else {
        return {
            'Content-Type' : 'multipart/form-data'            
        }
    }
}

export function authHeaderDownload() {
    // JSON.parse(window.localStorage.getItem('decon')).token
    // return authorization header with jwt token
    let user = JSON.parse(window.localStorage.getItem('decon'))

    if (user && user.token) {
        return { 
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Bearer ' + user.token 
        }
    } 
    else {
        return {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/utils.js